/**
 * Supplier delivery time slots (Phase 133). Mirrors backend/po_delivery.py TIME_SLOTS — keys, labels, windows and the
 * colour each slot gets on the project schedule's truck icons.
 */
export const DELIVERY_SLOTS = [
  { key: "first_up", label: "First Up", window: "7–9am", color: "#F59E0B", cls: "border-amber-500/40 bg-amber-500/10 text-amber-300" },
  { key: "mid_morning", label: "Mid Morning", window: "9–11am", color: "#0EA5E9", cls: "border-sky-500/40 bg-sky-500/10 text-sky-300" },
  { key: "lunch", label: "Lunch", window: "11am–1pm", color: "#22C55E", cls: "border-green-500/40 bg-green-500/10 text-green-300" },
  { key: "early_afternoon", label: "Early Afternoon", window: "1–3pm", color: "#F97316", cls: "border-orange-500/40 bg-orange-500/10 text-orange-300" },
  { key: "end_of_day", label: "End of Day", window: "3–5pm", color: "#6366F1", cls: "border-indigo-500/40 bg-indigo-500/10 text-indigo-300" },
];

const BY_KEY = Object.fromEntries(DELIVERY_SLOTS.map((s) => [s.key, s]));

export const slotMeta = (key) => BY_KEY[key] || null;
export const slotLabel = (key) => {
  const m = BY_KEY[key];
  return m ? `${m.label} (${m.window})` : "";
};
export const slotShort = (key) => BY_KEY[key]?.label || "";
export const slotColor = (key, fallback = "#64748B") => BY_KEY[key]?.color || fallback;

/** PO lifecycle shown to builders: Sent → Delivery confirmed → Delivered → Invoiced */
export const PO_STEPS = [
  { key: "sent", label: "Sent" },
  { key: "delivery_confirmed", label: "Delivery confirmed" },
  { key: "fully_delivered", label: "Delivered" },
  { key: "invoiced", label: "Invoiced" },
];
